import React from 'react';
import styles from './PlanHeader.module.css';
import TileRow from '../../../Utils/Tile/TileRow/TileRow';
import TileColumn from '../../../Utils/Tile/TileColumn/TileColumn';
import ProgressStatusBadge from '../../../Utils/ProgressStatusBadge/ProgressStatusBadge';

type PlanHeaderProps = {
  progressContent: React.ReactNode;
  actionsContent: React.ReactNode;
};

const PlanHeader = ({ progressContent, actionsContent }: PlanHeaderProps) => (
  <TileRow>
    <TileColumn>
      <ProgressStatusBadge status='inProgress' text='In Progress' />
    </TileColumn>
    <TileColumn>
      <div className={styles.buttonsSection}>
        {actionsContent}
      </div>
    </TileColumn>
  </TileRow>
);

export default PlanHeader;

